import React, { useState, useEffect, useMemo } from 'react'
import { Button, Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap'
import { Link } from 'react-router-dom'
import TableContainer from 'components/Common/TableContainer'
import {
    getIncomeStart,
} from "store/actions"
import { useDispatch, useSelector } from 'react-redux'
import { SrNo, IncomeRange } from './ManageIncomeCol'
import CreateIncomeRange from './CreateIncomeRange'
import Spinners from 'components/Common/Spinner'
import { toast } from 'react-toastify'
import UpdateIncomeRange from './UpdateIncomeRange'
const ManageIncomerRange = () => {
    const [modal, setModal] = useState({
        isShow: false,
    })

    const [updateModal, setUpdateModal] = useState(
        {
            isShow: false,
            range_from: "",
            range_to:"",
            id:""
        }
    )
    const dispatch = useDispatch();

    const handleEditModalOpen = (payload) =>{
        setUpdateModal({
            ...updateModal,
            isShow: true,
            id: payload.id,
            range_from: payload.range_from,
            range_to: payload.range_to
        })
    }

    const {
        Loading, errors, successMsg
    } = useSelector(state => state.ManageIncomeReducer)

    const { income, responseMsg } = useSelector(
        state => state.InsuranceNeedReducer
    )

    useEffect(() => {
        dispatch(getIncomeStart())
    }, [])

    useEffect(() => {
        if (errors && errors !== "") {
            toast.error(errors)
        }
        if (successMsg && successMsg !== "") {
            toast.success(successMsg)
            dispatch(getIncomeStart())
        }
    }, [errors, successMsg])

    const columns = useMemo(
        () => [
            {
                Header: "Sr No",
                accessor: (row, i) => i + 1,
                filterable: true,
                Cell: cellProps => {
                    return <SrNo {...cellProps} />
                },
            },
            {
                Header: "Income Range",
                accessor: "label",
                filterable: true,
                Cell: cellProps => {
                    return <IncomeRange {...cellProps} />
                },
            },
            {
                Header: "Action",
                accessor: "action",
                disableFilters: true,
                Cell: cellProps => {
                    return (
                        <>
                            <ul className="list-unstyled hstack gap-1 mb-0">
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-primary"
                                        onClick={() =>  handleEditModalOpen(cellProps.row.original)
                                        }
                                        id={`deletetooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="mdi mdi-pencil-outline" />
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`deletetooltip-${cellProps.row.original.id}`}
                                        >
                                            Edit Range
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>


                            </ul>
                        </>
                    )
                },
            },])
    return (
        <div className='page-content'>
            <Container fluid={true}>
                <Card>
                    <CardBody>
                        <div className='d-flex justify-content-between align-items-center'>
                            <p className='fs-4'>Manage Income Range</p> <Button color='primary' onClick={() => setModal({ ...modal, isShow: true })}>Add Income Range</Button>
                        </div>

                        <div className='mt-5'>
                            {
                                Loading ? <Spinners /> :

                                    <TableContainer
                                        columns={columns}
                                        data={income}
                                        isGlobalFilter={true}
                                        isAddOptions={false}
                                        // handleJobClicks={handleJobClicks}
                                        isJobListGlobalFilter={false}
                                        isPagination={true}
                                        iscustomPageSizeOptions={true}
                                        isShowingPageLength={true}
                                        customPageSize={15}
                                        tableClass="table-bordered align-middle nowrap mt-2"
                                        paginationDiv="col-sm-12 col-md-7"
                                        pagination="pagination justify-content-end pagination-rounded"
                                    />
                            }
                        </div>
                    </CardBody>
                </Card>
            </Container>


            <CreateIncomeRange modal={modal} setModal={setModal} />
            <UpdateIncomeRange modal={updateModal} setModal={setUpdateModal} />
        </div>
    )
}

export default ManageIncomerRange